import {Controller} from "stimulus"
import * as basicScroll from 'basicscroll'

/**
 * Form bone de recharge
 */
export default class extends Controller {

    static targets = [
        "dish"
    ]

    initialize() {

        // Exemple récup d'élément:
        //const $circle1 = this.element.querySelector(".js-circle-1")

        const $root = this.element
        if(this.dishTarget){
            const instance1 = basicScroll.create({
                elem: this.dishTarget,
                from: 'middle-middle',
                to: 'bottom-top',
                direct: true,
                props: {
                    '--rotation': {
                        from: '0deg',
                        to: '90deg'
                    },
                }
            })

            instance1.start()
        }

    }

}